import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenchmarkTimeseriesComponent } from './benchmark-timeseries/benchmark-timeseries.component';
import { WaterfallGraphComponent } from './waterfall-graph/waterfall-graph.component';
import { BurstAnalysisComponent } from './burst-analysis/burst-analysis.component';
import { CompareComponent } from './compare/compare.component';
import { ConcurrentconnectionTimeseriesComponent } from './concurrentconnection-timeseries/concurrentconnection-timeseries.component';
import { DevicestatsComponent } from './devicestats/devicestats.component';
import { DistributionComponent } from './distribution/distribution.component';
import { DonutComponent } from './donut/donut.component';
import { EditCardGraphComponent } from './edit-card-graph/edit-card-graph.component';
import { PieComponent } from './pie/pie.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { TimeseriesComponent } from './timeseries/timeseries.component';
import { WikiBargraphComponent } from './wiki-bargraph/wiki-bargraph.component';
import { WindowsizeTimeseriesComponent } from './windowsize-timeseries/windowsize-timeseries.component';
import { GaugeComponent } from './gauge/gauge.component';
import { ElementModule } from 'src/app/elements/element.module';
import { TitleRenderDirective } from 'src/app/directives/title-render.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartsModule } from 'ng2-charts';
import { NgScrollbarModule } from 'ngx-scrollbar';

@NgModule({
  declarations: [WaterfallGraphComponent, BenchmarkTimeseriesComponent, BurstAnalysisComponent, CompareComponent,
    ConcurrentconnectionTimeseriesComponent, DevicestatsComponent, DistributionComponent, DonutComponent, EditCardGraphComponent,
    GaugeComponent, PieComponent, ProgressBarComponent, TimeseriesComponent, WikiBargraphComponent, WindowsizeTimeseriesComponent, TitleRenderDirective],
  exports: [WaterfallGraphComponent, BenchmarkTimeseriesComponent, BurstAnalysisComponent, CompareComponent,
    ConcurrentconnectionTimeseriesComponent, DevicestatsComponent, DistributionComponent, DonutComponent,
    EditCardGraphComponent, GaugeComponent, PieComponent, ProgressBarComponent, TimeseriesComponent,
    WikiBargraphComponent, WindowsizeTimeseriesComponent],
  imports: [
    CommonModule,
    NgxChartsModule,
    ElementModule, FormsModule, ReactiveFormsModule, ChartsModule, NgScrollbarModule
  ]
})
export class GraphsModule { }
